import { useContext, useState } from "react";
import { NavPage } from "../../../services/NavService";
import { IMaterialListResponse, MaterialClient, MaterialItem } from "../../../services/WebApiClient";
import { LoginContext } from "../../EditorCommon/LoginContext";
import { LoadSpinner } from "../../LoadSpinner";
import { AdminNav } from "../AdminNav/AdminNav";
import { ImageSetter } from "./ImageSetter";


export function MaterialEditor(props: {}) {

    const loginContext = useContext(LoginContext);
    const [matsPromise, setMatsPromise] = useState<Promise<any> | undefined>(undefined);
    const [mats, setMats] = useState<IMaterialListResponse | undefined>(undefined);


    const matService = new MaterialClient(undefined, loginContext.loginService.http);
    if (!matsPromise) {
        const promise = matService.getMaterials().then(setMats);
        setMatsPromise(promise);
    }

    if (!mats) {
        return <LoadSpinner />;
    }


    function setSampleImage(mat: MaterialItem, f: File) {
        return matService.setSampleImage(mat.externalId, { data: f, fileName: mat.externalId })
            .then(response => response.path ?? undefined)
    }
    function setTextureImage(mat: MaterialItem, f: File) {
        return matService.setTextureImage(mat.externalId, { data: f, fileName: mat.externalId })
            .then(response => response.path ?? undefined)
    }

    const bodyRows = mats.materials.map(mat => (
        <tr key={mat.externalId}>
            <td>{mat.externalId}</td>
            <td>{mat.name}</td>
            <td>
                <ImageSetter url={mat.sampleImageUrl} onSet={f => setSampleImage(mat, f)} />
            </td>
            <td>
                <ImageSetter url={mat.textureImageUrl} onSet={f => setTextureImage(mat, f)} />
            </td>
        </tr>
    ));
    //TODO use <Table>
    return (
        <div>
            <AdminNav page={NavPage.Admin.Material} />
            <table>
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Name</th>
                        <th>Sample image</th>
                        <th>Texture image</th>
                    </tr>
                </thead>
                <tbody>
                    {bodyRows}
                </tbody>

            </table>
        </div>
    );
}
